export enum AttendeeMatchEvent {
  APPROVED = 'TL_ATTENDEE_MATCH_APPROVED',
  REJECTED = 'TL_ATTENDEE_MATCH_REJECTED',
  MATCHED = 'TL_ATTENDEE_MATCH_MATCHED',
}
